import type { BugReport } from "@thinkwithsophia/techne-ui";
import { supabase } from "./supabase";

// techne-ui produces a rich BugReport; we keep a light row plus the full payload (same shape
// as homestead's bug_reports). Reports are readable back by their author only.
export async function submitBugReport(
  report: BugReport,
  subjectId: string | null,
): Promise<boolean> {
  const { error } = await supabase.from("bug_reports").insert({
    user_id: subjectId,
    category: report.category ?? "mechanical",
    note: report.note,
    route: report.route,
    build_id: report.build,
    payload: report as unknown as Record<string, unknown>,
  });
  if (error) {
    console.error("bug report insert failed:", error);
    return false;
  }
  return true;
}
